// Après une visite Turbo (pas au premier chargement) : focus sur le contenu
// de la page (#contenu), que les lecteurs d'écran annoncent comme une
// nouvelle page ; rien quand un champ porte autofocus, quand la page a déjà
// posé le focus (champ fautif, fenêtre) ou quand l'adresse vise une ancre.
// Les Frames et les Turbo Streams ne déclenchent pas turbo:load.
let firstLoad = true;

document.addEventListener('turbo:load', () => {
    if (firstLoad) {
        firstLoad = false;
        return;
    }
    if (window.location.hash || document.querySelector('[autofocus]')) return;
    const active = document.activeElement;
    if (active && active !== document.body) return;
    document.getElementById('contenu')?.focus({ preventScroll: true });
});
